export const APP_UPDATE = 'APP_UPDATE'
export const APP_UPDATE_CURRENT_ACCOUNT_ID = 'APP_UPDATE_CURRENT_ACCOUNT_ID'
export const APP_UPDATE_CURRENT_ACCOUNT = 'APP_UPDATE_CURRENT_ACCOUNT'
export const APP_RESET_CURRENT_ACCOUNT = 'APP_RESET_CURRENT_ACCOUNT'
export const APP_UPDATE_THREADS_STATS = 'APP_UPDATE_THREADS_STATS'
export const APP_APPLY_OPTIN_REQUIRED = 'APP_APPLY_OPTIN_REQUIRED'
export const APP_DROP_OPTIN_REQUIRED = 'APP_DROP_OPTIN_REQUIRED'
export const APP_SET_SMS_EMAIL_OPTIN_ERRORS = 'APP_SET_SMS_EMAIL_OPTIN_ERRORS'
export const APP_DROP_SMS_EMAIL_OPTIN_ERRORS = 'APP_DROP_SMS_EMAIL_OPTIN_ERRORS'
export const APP_APPLY_SMS_EMAIL_OPTIN_REQUIRED = 'APP_APPLY_SMS_EMAIL_OPTIN_REQUIRED'
export const APP_DROP_SMS_EMAIL_OPTIN_REQUIRED = 'APP_DROP_SMS_EMAIL_OPTIN_REQUIRED'
export const APP_APPLY_WHATSAPP_OPTIN_REQUIRED = 'APP_APPLY_WHATSAPP_OPTIN_REQUIRED'
export const APP_DROP_WHATSAPP_OPTIN_REQUIRED = 'APP_DROP_WHATSAPP_OPTIN_REQUIRED'
export const APP_APPLY_TELEGRAM_OPTIN_REQUIRED = 'APP_APPLY_TELEGRAM_OPTIN_REQUIRED'
export const APP_DROP_TELEGRAM_OPTIN_REQUIRED = 'APP_DROP_TELEGRAM_OPTIN_REQUIRED'
export const SUBSCRIBER_ADMIN_CREATE_OR_UPDATE = 'SUBSCRIBER_ADMIN_CREATE_OR_UPDATE'
export const APP_SET_ACTIVE_TAB = 'APP_SET_ACTIVE_TAB'
export const APP_SET_TITLE = 'APP_SET_TITLE'
export const APP_LOAD_FBSDK_REQUEST = 'APP_LOAD_FBSDK_REQUEST'
export const APP_LOAD_FBSDK_SUCCESS = 'APP_LOAD_FBSDK_SUCCESS'
export const APP_CLEAR_PERM_ERROR = 'APP_CLEAR_PERM_ERROR'
export const FORCE_UPDATE_STATE = 'FORCE_UPDATE_STATE'
export const APP_SET_BOT_TIMEZONE = 'APP_SET_BOT_TIMEZONE'
export const APP_RESET_BOT_TIMEZONE = 'APP_RESET_BOT_TIMEZONE'

export const APP_SET_PAGE_NAME = 'APP_SET_PAGE_NAME'

export const NEW_POLICY_ENFORCEMENT_NOTIFICATION_NOTIFICATION =
  'NEW_POLICY_ENFORCEMENT_NOTIFICATION_NOTIFICATION'
export const READ_POLICY_ENFORCEMENT_NOTIFICATION_NOTIFICATION =
  'READ_POLICY_ENFORCEMENT_NOTIFICATION_NOTIFICATION'

export const CONNECT_FB_CHANNEL = 'CONNECT_FB_CHANNEL'

export const FETCH_PREVIEW_REF_URL = 'FETCH_PREVIEW_REF_URL'
export const FETCH_PREVIEW_REF_URL_RESPONSE = 'FETCH_PREVIEW_REF_URL_RESPONSE'

export const SET_PRO_STATUS_BLOCKED = 'SET_PRO_STATUS_BLOCKED'
export const SET_PRO_STATUS_UNBLOCKED = 'SET_PRO_STATUS_UNBLOCKED'

export const ACCOUNT_SET_DISPLAY_FLAG = 'ACCOUNT_SET_DISPLAY_FLAG'
export const ACCOUNT_SET_DISPLAY_FLAG_RESPONSE = 'ACCOUNT_SET_DISPLAY_FLAG_RESPONSE'
export const ACCOUNT_SET_DISPLAY_FLAG_ERROR = 'ACCOUNT_SET_DISPLAY_FLAG_ERROR'

export const CURRENT_ACCOUNT_UPDATE_ASYNC_BILLING_ACTIONS =
  'CURRENT_ACCOUNT_UPDATE_ASYNC_BILLING_ACTIONS'

export const CURRENT_ACCOUNT_UPDATE_WHATSAPP_CHANNEL = 'CURRENT_ACCOUNT_UPDATE_WHATSAPP_CHANNEL'
export const APP_SET_LAST_PREVIEW_BUILDER_ID = 'APP_SET_LAST_PREVIEW_BUILDER_ID'
export const APP_SET_WHATSAPP_OPTIN_MODAL_OPEN = 'APP_SET_WHATSAPP_OPTIN_MODAL_OPEN'
